import { StoreBase } from '../../../common/StoreBase';
import { action, computed, observable } from 'mobx';
import { IQueryOrValue } from '@kurtosys/ksys-app-template/dist/models/query';
import { IAccessibilityValues } from '../../../models/accessibility/IAccessibilityValues';
import { getValueFromDotNotation } from '@kurtosys/ksys-app-template/dist/utils/object';
import { isNullOrEmpty } from '@kurtosys/ksys-app-template/dist/utils/typeChecks';

export class AccessibilityStore extends StoreBase {
	values: IAccessibilityValues = {};

	constructor(props: any) {
		super(props);
		this.accessibilityText = this.accessibilityText.bind(this);
	}

	@action
	async initialize(): Promise<void> {
		this.values = this.accessibilityValues;
	}

	@computed
	get appConfiguration() {
		return this.storeContext.appStore && this.storeContext.appStore.configuration;
	}

	@computed
	get accessibilityValues(): IAccessibilityValues {
		const accessibilityConfig = (this.appConfiguration && this.appConfiguration.accessibilityConfig) || {};
		const config: IAccessibilityValues = this.orchestrateConfigKeys(accessibilityConfig);
		return config;
	}

	orchestrateConfigKeys(obj: {}) {
		const orchestratedObj: { [key: string]: string | {} | undefined } = {};
		const result = Object.entries<typeof obj>(obj).map((elem) => {
			const parentKey = elem[0];
			const configOption = elem[1];
			const configOptionKeys = Object.keys(configOption);
			const retObj: { [key: string]: string | {} | undefined } = {};

			if (configOptionKeys.includes('query') || configOptionKeys.includes('value')) {
				retObj[parentKey] = this.getOptionQueryOrValue(configOption);
			}
			else {
				retObj[parentKey] = this.orchestrateConfigKeys(configOption);
			}

			return retObj;
		});

		for (const elem of result) {
			Object.assign(orchestratedObj, elem);
		}

		return orchestratedObj;
	}

	getOptionQueryOrValue(configOption: IQueryOrValue): string | undefined {
		if (configOption) {
			if (configOption.query) {
				return this.getQueryValue(configOption.query);
			}
			return configOption.value || undefined;
		}
	}

	accessibilityText = (key: string, defaultValue: string) => {
		if (isNullOrEmpty(this.values)) {
			this.initialize();
		}
		if (!key.startsWith('asset')) {
			key = 'asset.' + key;
		}
		return getValueFromDotNotation(key, this.values, defaultValue);
	}
}
